var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 49.9996C100 77.6139 77.6146 100 50.0004 100C22.3861 100 0 77.6139 0 49.9996C0 22.3854 22.3861 0 50.0004 0C77.6146 0 100 22.3854 100 49.9996Z",
    fill: "#BAE3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9902 75.8643V85.7165H75.8621C78.5717 85.7165 80.7882 83.5 80.7882 80.7904V75.8643H33.9902Z",
    fill: "#B4B4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7044 14.2861H24.1379C26.8475 14.2861 29.064 16.5026 29.064 19.2122V80.7886C29.064 83.4982 31.2806 85.7147 33.9902 85.7147C36.6998 85.7147 38.9163 83.4982 38.9163 80.7886V75.8625H74.6306V19.2122C74.6306 16.5026 72.414 14.2861 69.7044 14.2861Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.084 52.4629H70.9363V54.926H61.084V52.4629Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7588 52.4629H58.6208V54.926H32.7588V52.4629Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3057 57.3877H70.9362V59.8507H46.3057V57.3877Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7588 57.3877H43.8425V59.8507H32.7588V57.3877Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9261 67.2432H70.9359V69.7062H54.9261V67.2432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7588 67.2432H52.4632V69.7062H32.7588V67.2432Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3693 37.1914L51.2316 37.6838L52.0939 37.1914C56.1577 34.4818 58.6207 29.8022 58.6207 24.8761V21.674L51.2316 19.2109L43.8424 21.674V24.8761C43.8424 29.8022 46.3055 34.3585 50.3693 37.1914Z",
    fill: "#0967D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7389 32.5142L49.3841 30.4209C51.1081 29.1894 52.3396 27.3421 52.4629 25.125L54.926 25.3715C54.6794 28.3271 53.0787 30.9134 50.7389 32.5142Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1477 62.3184H70.9359V64.7814H40.1477V62.3184Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7588 62.3184H37.6849V64.7814H32.7588V62.3184Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3053 47.5381H70.9358V50.0011H46.3053V47.5381Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7588 47.5381H43.8425V50.0011H32.7588V47.5381Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.611 41.3789H59.8524V43.842H42.611V41.3789Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1379 14.2861C26.8475 14.2861 29.064 16.5026 29.064 19.2122V27.8329H19.2118V19.2122C19.2118 16.5026 21.4283 14.2861 24.1379 14.2861Z",
    fill: "#B4B4B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.4286,
    height: 71.4286,
    fill: "white",
    transform: "translate(14.2857 14.2861)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.7fd277d6ec32d7a0e679c41e9d72d2a0.svg";
export { ForwardRef as ReactComponent };